import 'jquery';
import 'rails-ujs';
import 'url';
import '~/vendor/assets/javascripts/jquery.cookie-manager';
import '~/app/assets/javascripts/requireable.coffee';
